import React, { useRef } from 'react'
import loadable from '@loadable/component'
//import LeadFormModal from './LeadFormModal'

const LeadFormModal = loadable(() => import('./LeadFormModal'), {
  ssr: false
})

export default function LeadModal(props) {
  const ref = useRef()

  if (!ref.current && props.isOpen) {
    ref.current = true
  }

  if (ref.current === undefined) {
    return null
  }

  return (
    <LeadFormModal {...props} />
  )
}
